var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRTopnavClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-topnav-close",
    x: 0.054,
    y: 0.634,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconR-topnav-close1",
    serifid: "iconR-topnav-close",
    d: "M30.703,29.588l-8.955,-8.955l8.955,-8.955c0.216,-0.216 0.35,-0.516 0.35,-0.846c0,-0.662 -0.536,-1.198 -1.198,-1.198c-0.33,-0 -0.63,0.134 -0.846,0.35l-8.955,8.955l-8.955,-8.955c-0.217,-0.216 -0.516,-0.35 -0.847,-0.35c-0.661,-0 -1.198,0.536 -1.198,1.198c0,0.33 0.134,0.63 0.351,0.846l8.955,8.955l-8.955,8.955c-0.217,0.217 -0.351,0.516 -0.351,0.847c0,0.661 0.537,1.198 1.198,1.198c0.331,-0 0.63,-0.134 0.847,-0.351l8.955,-8.954c-0,-0 8.955,8.954 8.955,8.954c0.216,0.217 0.516,0.352 0.847,0.352c0.662,-0 1.198,-0.537 1.198,-1.198c0,-0.331 -0.134,-0.631 -0.351,-0.848l-0,0Z",
    style: {
      fill: "#808080",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRTopnavClose);
export default __webpack_public_path__ + "static/media/iconR-topnav-close.c34311eaad692ea573c3d9510a04c199.svg";
export { ForwardRef as ReactComponent };